import React  from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getMemberById } from "../../../api/apiServices";
import { useQuery } from 'react-query';
import './Membership.css'

const ViewInactiveMember = (props) => {
   
    const params = useParams();
    const id = parseInt(params.id)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/inactive_members";

    const {
        isLoading,
        isError,
        error,
        data: member
    } = useQuery(['member', id], () => getMemberById(id));
    console.log(member?.data)

    const handleCancel = () => {
        navigate(from, { replace: true });
    }

    let content
    if (isLoading) {
        content = <p>Loading...</p>
    } else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content = member?.data.map(member => (

            <div className="data-table">
                <legend style={{ fontSize: "24px", fontWeight: "700", color: "white" }}>Member Information</legend>
                <div className="profile-picture">
                    <img src={`/images/members/${member?.profile_picture}`} className="image" alt="" />
                </div>
                <table className="table table-borderless">
                    <tbody>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>PF Number</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "no-wrap" }}> :	{member.pf_number}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>NDC Number</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.ndc_membership_number}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>VoterID Number</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.voter_id_number}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>LastName</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.last_name}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>FirstName</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.first_name}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>MiddleName</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.middle_name}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Date of Birth</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.date_of_birth}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Gender</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.gender}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Marital setMaritalStatus</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.marital_status}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Mobile Number</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.mobile_number}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email Address</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.email}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Date Joined</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.date_joined}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Region</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.region}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Constituency</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.constituency}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Branch</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.branch}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Qualifications</td>
                            <td colSpan="3" style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.qualification}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Profession</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.profession}</td>
                        </tr>
                        <tr>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Occupations</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.occupations}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Employment Type</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member?.employment_type}</td>
                            <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Current Employment</td>
                            <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{member.current_employment}</td>
                        </tr>
                        <tr>
                            <td colSpan="6" style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>
                                <form>
                                    <div className="form-group row">
                                        <label htmlFor="" className="col-sm-5 col-form-label"></label>
                                        <div className="col-sm-1">
                                            <button type="submit" className="btn btn-danger" onClick={handleCancel}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        ));
    }

    return (
        <>
            <section className="content-header">
                <h1>Inactive Member </h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>Member Information</span>      
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ViewInactiveMember;


